import { AuthProvider } from "@/lib/auth/auth";
import SidebarProvider from "@/lib/components/sidebar/sidebar.provider";
import { ImperativeDialogRoot } from "@/lib/components/ui/imperative-dialog";
import { TanstackQueryProvider } from "@/lib/tanstack-query";
import ThemeProvider from "@/lib/theme/theme-provider";
import { ThemedToaster } from "@/lib/theme/themed-toaster";
import { OrgSelectionGate, TenantsProvider } from "@/modules/tenants";
import { UploadRestrictionsWarmup } from "@/modules/uploads";
import { Suspense } from "react";
import { Outlet } from "react-router";
import { FullPageSpinner } from "../lib/components/ui/spinner";

export default function AppLayout() {
  return (
    <AuthProvider>
      <TanstackQueryProvider>
        <ThemeProvider>
          <SidebarProvider>
            <UploadRestrictionsWarmup />
            <OrgSelectionGate>
              <TenantsProvider>
                <Suspense fallback={<FullPageSpinner className="min-h-svh" />}>
                  <Outlet />
                </Suspense>
              </TenantsProvider>
            </OrgSelectionGate>
            <ImperativeDialogRoot />
            <ThemedToaster />
          </SidebarProvider>
        </ThemeProvider>
      </TanstackQueryProvider>
    </AuthProvider>
  );
}
